import { useEffect } from "react";
import useNotificationsStore from "@stores/shared/useNotificationsStore";
import useNotificationChannelStore from "@stores/shared/useNotificationChannelStore";
import { useAuth } from "@context/shared/AuthContext";
import { isAccreditor } from "@config/shared/roles";

const POLL_INTERVAL_MS = 5 * 60 * 1000;

// Loads the signed-in user's notifications, then keeps them current: the live channel
// re-fetches them when they change (ADR-0051), and the five-minute poll is the safety net
// for when the channel is down.
export const useNotificationPolling = () => {
  const { isAuthenticated, user } = useAuth();
  const { fetchItems } = useNotificationsStore();

  useEffect(() => {
    // Accreditors have no notifications UI (NotificationsButton is hidden
    // for that role), and the endpoint 403s for it — skip polling entirely.
    if (!isAuthenticated || isAccreditor(user?.roleId)) return;

    const fetchNotifications = async () => {
      try {
        await fetchItems();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, POLL_INTERVAL_MS);
    const unwatch = useNotificationChannelStore.getState().watch();
    return () => {
      clearInterval(intervalId);
      unwatch();
    };
  }, [isAuthenticated, user, fetchItems]);
};
